export default __webpack_public_path__ + "static/media/ic-planilla.4eb9335a.svg";